<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Ref",
        value: "ref",
        sortable: false
      },
      {
        text: "Discip Action",
        value: "discipAction",
        sortable: false
      },
      {
        text: "DiscipDate",
        value: "discipDate",
        sortable: false
      },
      {
        text: "NoteExplDate",
        value: "noteExplDate",
        sortable: false
      },
      {
        text: "WritExplDate",
        value: "writeExplDate",
        sortable: false
      },
      {
        text: "MemoDate",
        value: "memoDate",
        sortable: false
      },
      {
        text: "MemoRefNo",
        value: "memoRefNo",
        sortable: false
      },
      {
        text: "SuspendedFrom",
        value: "suspendedFrom",
        sortable: false
      },
      {
        text: "SuspendedTo",
        value: "suspendedTo",
        sortable: false
      },
      {
        text: "Signatory",
        value: "signatory",
        sortable: false
      },
      {
        text: "WithAR",
        value: "withAR",
        sortable: false
      },
      {
        text: "PrevSuspension",
        value: "prevSuspension",
        sortable: false
      },
      {
        text: "Status",
        value: "status",
        sortable: false
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false
      },
      {
        text: "NoOfOffense",
        value: "noOfOffense",
        sortable: false
      },
      {
        text: "ReceivedDate",
        value: "receivedDate",
        sortable: false
      },
      {
        text: "TerminationDate",
        value: "terminationDate",
        sortable: false
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "DISCCASE"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return (
          item.property == "ALL" &&
          item.mode == "DISCCASE" &&
          item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>